import { z } from 'zod';

import { transformKeysToCamelCase } from 'utils/formatters/transform-snake-to-camel';

export const ReferralLinksResponseSchema = z
  .object({
    data: z.record(
      z.string(),
      z.object({
        name: z.string(),
        code: z.string(),
        link: z.string(),
        path: z.string(),
        sales_commission: z.number(),
        customer_discount: z.number(),
        earned: z.number(),
        conversion: z.number(),
      }),
    ),
  })

  .transform(transformKeysToCamelCase);

export type TReferralLinksResponse = z.infer<typeof ReferralLinksResponseSchema>;
export type TReferralLinksData = z.infer<typeof ReferralLinksResponseSchema>['data'][string];
